import { render } from "./AlloyDialog.vue?vue&type=template&id=d56fce52&ts=true"
import script from "./AlloyDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlloyDialog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/AlloyDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d56fce52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d56fce52', __exports__)) {
    api.reload('d56fce52', __exports__)
  }
  
  module.hot.accept("./AlloyDialog.vue?vue&type=template&id=d56fce52&ts=true", () => {
    api.rerender('d56fce52', render)
  })

}


export default __exports__